import { render } from "./App.vue?vue&type=template&id=be9eb9a0"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=be9eb9a0&lang=scss"
script.render = render

export default script